import * as React from 'react'

const SvgAirMathsLogo = (props) => (
  <svg
    width="204"
    height="24"
    viewBox="0 0 204 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.4093 23.7341L18.2516 18.7216H8.52547L6.3678 23.7341H0.857422L10.8823 0.530762H15.8948L25.9197 23.7341H20.4093ZM13.4051 7.43533L10.484 14.1739H16.2931L13.4051 7.43533Z"
      fill="#FF692E"
    />
    <path
      d="M28.6124 0.530762H33.7908V23.7341H28.6124V0.530762Z"
      fill="#FF692E"
    />
    <path
      d="M58.326 8.23201C58.326 11.9499 56.8544 14.351 53.9111 15.4353L59.7866 23.7341H53.4132L48.268 16.3316H44.6829V23.7341H39.5045V0.530762H48.3011C51.9083 0.530762 54.4754 1.13934 56.0024 2.35649C57.5515 3.57364 58.326 5.53215 58.326 8.23201ZM48.4671 11.8503C50.2375 11.8503 51.4436 11.5626 52.0854 10.9872C52.7271 10.4118 53.048 9.50448 53.048 8.2652C53.048 7.00379 52.7161 6.14072 52.0522 5.67599C51.3883 5.21126 50.2265 4.9789 48.5667 4.9789H44.6829V11.8503H48.4671Z"
      fill="#FF692E"
    />
    <path
      d="M106.96 9.12863L100.686 21.8091H97.5988L91.3581 9.12863V23.7344H86.1797V0.531119H93.1838L99.1589 13.278L105.167 0.531119H112.138V23.7344H106.96V9.12863Z"
      fill="#FF692E"
    />
    <path
      d="M134.382 23.7344L132.225 18.722H122.498L120.341 23.7344H114.83L124.855 0.531119H129.868L139.893 23.7344H134.382ZM127.378 7.43568L124.457 14.1743H130.266L127.378 7.43568Z"
      fill="#FF692E"
    />
    <path
      d="M150.725 5.01245V23.7344H145.547V5.01245H138.974V0.531119H157.298V5.01245H150.725Z"
      fill="#FF692E"
    />
    <path
      d="M175.502 0.531119H180.68V23.7344H175.502V14.6058H166.274V23.7344H161.095V0.531119H166.274V10.2241H175.502V0.531119Z"
      fill="#FF692E"
    />
    <path
      d="M193.85 4.54772C192.986 4.54772 192.3 4.75795 191.791 5.17842C191.305 5.57676 191.061 6.11895 191.061 6.80498C191.061 7.46888 191.36 8 191.957 8.39834C192.577 8.79668 193.982 9.27248 196.173 9.82573C198.386 10.3568 200.101 11.1646 201.318 12.249C202.536 13.3333 203.144 14.9156 203.144 16.9958C203.144 19.0761 202.359 20.769 200.787 22.0747C199.238 23.3582 197.191 24 194.646 24C190.973 24 187.664 22.639 184.721 19.917L187.808 16.1328C190.309 18.3237 192.621 19.4191 194.746 19.4191C195.697 19.4191 196.439 19.2199 196.97 18.8216C197.523 18.4011 197.8 17.8479 197.8 17.1618C197.8 16.4537 197.512 15.9004 196.937 15.5021C196.361 15.0816 195.222 14.6611 193.518 14.2407C190.818 13.5989 188.837 12.769 187.576 11.751C186.336 10.7109 185.717 9.09544 185.717 6.90456C185.717 4.69156 186.502 2.98755 188.074 1.79253C189.667 0.597511 191.648 0 194.016 0C195.565 0 197.114 0.26556 198.663 0.79668C200.212 1.3278 201.562 2.08022 202.713 3.05394L200.09 6.83817C198.076 5.3112 195.996 4.54772 193.85 4.54772Z"
      fill="#FF692E"
    />
    <path
      d="M71.199 15.1453C70.6458 14.5699 70.3691 13.8728 70.3691 13.054C70.3691 12.2352 70.6458 11.5491 71.199 10.9959C71.7744 10.4205 72.4715 10.1328 73.2903 10.1328C74.1091 10.1328 74.7951 10.4205 75.3484 10.9959C75.9238 11.5491 76.2115 12.2352 76.2115 13.054C76.2115 13.8728 75.9238 14.5699 75.3484 15.1453C74.7951 15.6985 74.1091 15.9751 73.2903 15.9751C72.4715 15.9751 71.7744 15.6985 71.199 15.1453Z"
      fill="#FF692E"
    />
  </svg>
)

export default SvgAirMathsLogo
